export default __webpack_public_path__ + "static/media/1_0120.19571444.webp";